import {
  User,
  Mail,
  Phone,
  MapPin,
  Calendar,
  ShieldCheck,
  ShieldX,
} from "lucide-react";

import "./CustomerProfileCard.css";

function CustomerProfileCard({ customer }) {

  const joinedDate = customer?.createdAt
    ? new Date(customer.createdAt).toLocaleDateString("en-IN")
    : "Not Available";

  const profileItems = [

    {
      icon: <User size={18} />,
      label: "Full Name",
      value: customer?.name || "Not Available",
    },

    {
      icon: <Mail size={18} />,
      label: "Email Address",
      value: customer?.email || "Not Available",
    },

    {
      icon: <Phone size={18} />,
      label: "Mobile Number",
      value: customer?.phone || "Not Available",
    },

    {
      icon: <MapPin size={18} />,
      label: "City",
      value: customer?.city || "Not Available",
    },

    {
      icon: <MapPin size={18} />,
      label: "Address",
      value: customer?.address || "Not Available",
    },

    {
      icon: <Calendar size={18} />,
      label: "Joined On",
      value: joinedDate,
    },

  ];

  return (

    <div className="customer-profile-card">

      <h2 className="customer-card-title">

        Customer Profile

      </h2>

      <div className="customer-profile-header">

        <div className="customer-avatar">

          {customer?.name?.charAt(0)?.toUpperCase() || "C"}

        </div>

        <div className="customer-profile-info">

          <h2>

            {customer?.name || "Customer"}

          </h2>

          <p>

            {customer?.email || "No Email"}

          </p>

          <span
            className={
              customer?.isActive
                ? "customer-status-badge active"
                : "customer-status-badge blocked"
            }
          >
            {customer?.isActive ? (
              <ShieldCheck size={15} />
            ) : (
              <ShieldX size={15} />
            )}

            {customer?.isActive
              ? "Active Account"
              : "Blocked Account"}

          </span>

        </div>

      </div>

      <div className="customer-info-grid">

        {profileItems.map((item, index) => (

          <div
            className="customer-info-item"
            key={index}
          >

            <div className="customer-info-icon">

              {item.icon}

            </div>

            <div className="customer-info-content">

              <span>

                {item.label}

              </span>

              <h4>

                {item.value}

              </h4>

            </div>

          </div>

        ))}

      </div>

    </div>

  );

}

export default CustomerProfileCard;